import { render } from "./ProfileEstateUpdate.vue?vue&type=template&id=3dfeb4fc&scoped=true&ts=true&lang=pug"
import script from "./ProfileEstateUpdate.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileEstateUpdate.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileEstateUpdate.vue?vue&type=style&index=0&id=3dfeb4fc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dfeb4fc"]])

export default __exports__